@for (gallery of galleries(); track $index) {
    @if(gallery.videos && gallery.videos.length){
        <lsa-video-collage [videos]="gallery.videos!" [title]="gallery.name!" (click)="openPlaylist(gallery)">
        </lsa-video-collage>
    }
    @else if(gallery.videoUrl != undefined){
        <lsa-video-card [video]="gallery" ></lsa-video-card>
    }
}